import type { CheckboxGroupType, SelectOptionType } from '~/presentation/reports/ui/type';
import type { IRItemInfo } from '~/presentation/reports/common/ReportFilter/types';

import { EReportControlId, ERFilterKey } from '~/presentation/reports/common/ReportFilter/types';

export const CONTROL_FILTER_INFO: IRItemInfo = {
  [ERFilterKey.DEVICE]: {
    title: 'Device',
    content: 'View data from customers using specific devices',
    helps: [],
  },
  [ERFilterKey.TRAFFIC_SOURCE]: {
    title: 'Traffic source',
    content: 'View data from where customers arrived at your store',
    helps: [],
  },
  [ERFilterKey.VISITOR]: {
    title: 'Customer type',
    content: 'View data from specific customer type (e.g. New or Returning)',
    helps: [],
  },
  [ERFilterKey.EXPERIMENT]: {
    title: 'Experiment',
    content: 'View data collected from a specific A/B testing experiment',
    helps: [],
  },
  [ERFilterKey.PAGE]: {
    title: 'Page',
    content: 'View data from a specific page within your experiment or store',
    helps: [],
  },
  [ERFilterKey.VERSION]: {
    title: 'Version',
    content: 'View data from a specific template version',
    helps: [],
  },
};

const ORDER_FILTER_OPTIONS: SelectOptionType[] = [
  {
    label: 'Device',
    value: ERFilterKey.DEVICE,
  },
  {
    label: 'Traffic source',
    value: ERFilterKey.TRAFFIC_SOURCE,
  },
  {
    label: 'Customer type',
    value: ERFilterKey.VISITOR,
  },
  {
    label: 'Experiment',
    value: ERFilterKey.EXPERIMENT,
  },
  {
    label: 'Page',
    value: ERFilterKey.PAGE,
  },
  {
    label: 'Version',
    value: ERFilterKey.VERSION,
  },
];

export const ORDER_FILTER_GROUP: CheckboxGroupType = [
  {
    title: '',
    options: ORDER_FILTER_OPTIONS,
  },
];

// Mapping from ERFilterKey to the corresponding control IDs that hold the actual values
export const FILTER_KEY_TO_CONTROL_IDS: Record<string, EReportControlId[]> = {
  [ERFilterKey.DEVICE]: [EReportControlId.DEVICE, EReportControlId.DEVICES],
  [ERFilterKey.VISITOR]: [EReportControlId.VISITOR, EReportControlId.VISITORS],
  [ERFilterKey.TRAFFIC_SOURCE]: [EReportControlId.TRAFFIC_SOURCE, EReportControlId.TRAFFIC_SOURCES],
  [ERFilterKey.VERSION]: [EReportControlId.VERSION, EReportControlId.VERSIONS],
  [ERFilterKey.PAGE]: [EReportControlId.SINGLE_PAGE, EReportControlId.LIST_PAGE],
  [ERFilterKey.EXPERIMENT]: [
    EReportControlId.TAB_CAMPAIGN,
    EReportControlId.SINGLE_CAMPAIGN,
    EReportControlId.GROUP_CAMPAIGN,
    EReportControlId.PRICE_CAMPAIGN,
    EReportControlId.URL_CAMPAIGN,
  ],
};
